<template>
<div id="session-container-wrap">

<div class="filter-wrap">
  <div>  
    <Input v-model="sessionKeyword" @on-enter="getSearchSession" placeholder="输入买家名" size="small">
    <Icon type="ios-search" slot="prefix" />
    </Input>
  </div>

  <div>  
    <Dropdown @on-click="selectDropItem" trigger="click">
        <a style="padding: 0px 10px;" href="javascript:void(0)">
            <Icon size="16" color="#666" type="ios-funnel" />
        </a>
        <DropdownMenu slot="list">
            <DropdownItem name="all"><Icon color="#ff6a00" v-show="searchKey == 'all'" type="md-checkmark" />ALL message</DropdownItem>
            <DropdownItem name="noreply"><Icon color="#ff6a00" v-show="searchKey == 'noreply'" type="md-checkmark" />未回复</DropdownItem>
           
        </DropdownMenu>
    </Dropdown>
    <span style="color: rgb(255, 106, 0);font-size: 10px;">{{searchKeyText}}</span>
  </div>
</div>
  <div class="session-container">

    <div class="group-box">
      <Scroll v-show="(sessionKeyword != '' || searchKey != 'all')" :on-reach-bottom="getSearchSessionMore" :height="scrollHeight">
    <ul class="user-list">
      <li class="user" @click="showChat(session)" :class="currentSession && currentSession.session_id === session.session_id ? 'active' : ''" v-for="(session, index) in searchSession.data" :key="index">
        <a
          href="javascript:"
        >
          <i v-if="session.unread_count > 0">{{ session.unread_count }}</i>
          <img class="head_img" :src="session.head_url">
          <b style="width: 110px;" class="text-cut">{{ session.title }}</b>
          <p style="width: 110px;" class="text-cut">{{ session.summary }}</p>
          <p style="width: 95px;left: auto;right: 0px;color: rgb(255, 106, 0);font-size: 14px;" class="text-cut">{{ session.store_name }}</p>
          <span class="last_message_time"><Time :time="session.last_message_time*1" /></span>
        </a>
        <Icon type="md-close" @click="delChat(session)"></Icon>
      </li>
      <Empty :load="searchSession.load"></Empty>
    </ul>
    </Scroll>
    </div>


    <div v-for="(item, i) in sessionData" :key="i" class="group-box">
      <Collapse v-show="(i == seller_id && (sessionKeyword == '' &&  searchKey == 'all') )" v-model="collapseIndex"  >
      <Panel name="1">
        未分配
        <p slot="content" style="position: relative;">
          <Dropdown placement="bottom-start" :stop-propagation="true" trigger="click" style="margin-left: 20px;position: absolute;top: -45px;right: 10px;">
              <a href="javascript:void(0)">
                <span v-if="assignMode == 'view'">视图模式</span>
                  <span v-if="assignMode == 'invitation'">邀请模式</span>
              </a>
              <DropdownMenu style="width: 150px;padding: 0px 5px;" slot="list">
                <DropdownItem @click.native="assignMode = 'view'">视图模式</DropdownItem>
                <DropdownItem @click.native="assignMode = 'invitation'">邀请模式</DropdownItem>                  
              </DropdownMenu>
          </Dropdown>
          <Scroll :height="collapseItemHeight" :on-reach-bottom="invitionMoreSession" :distance-to-edge="-20">
            <ul style="padding-bottom: 20px;" v-if="(i == seller_id && (sessionKeyword == '' &&  searchKey == 'all') && item.invition )" class="user-list">
              
              <li @contextmenu="showMenu(index)" class="user" @click="invitation(session)" :class="currentSession && currentSession.session_id === session.session_id ? 'active' : ''" v-for="(session, index) in item.invition.data" :key="index">
                <a
                  href="javascript:"
                >
                  <i v-if="session.unread_count > 0">{{ session.unread_count }}</i>
                  <img class="head_img" :src="session.head_url">
                  <b style="width: 110px;" class="text-cut">{{ session.title }}</b>
                  <p style="width: 110px;" class="text-cut">{{ session.summary }}</p>
                  <span class="last_message_time"><Time :time="session.last_message_time*1" /></span>
                  <Badge v-if="session.transfer_mark == 1" style="position: absolute;right: 18px;top: 0px;" text="转" type="primary">
                      <a href="#" class="demo-badge"></a>
                  </Badge>
                </a>
                <vue-context-menu
                  :contextMenuData="contextMenuData"
                  :transferIndex="transferIndex"
                  @Handler1="transferCsrModelShow(session)"
                ></vue-context-menu>
              </li>
            </ul>
          </Scroll>
        </p>
      </Panel>
      <Panel name="2">
        已分配
        
        <p id="recently_wrap" style="position: relative;" slot="content">

            <Dropdown placement="bottom-start" :stop-propagation="true" trigger="click" style="margin-left: 20px;position: absolute;top: -45px;right: 10px;">
                <a href="javascript:void(0)">
                    <Icon size="16" color="#666" type="ios-funnel" />
                </a>
                <DropdownMenu style="width: 150px;padding: 0px 5px;" slot="list">
                  <Scroll :height="200">
                      <DropdownItem styel="text-align: center;border-bottom: 1px solid #eee;" @click.native="csrSession('all')">
                          <span>全部</span>
                      </DropdownItem>
                      <DropdownItem @click.native="csrSession(null)">
                        <div style="display: flex;justify-content: space-between;">
                          <span>我的</span>
                          <span><Badge status="success" text="在线" /></span>
                        </div>
                      </DropdownItem>
                      <DropdownItem @click.native="csrSession(user)" :key="index" v-for="(user, index) in childUser">
                        <div style="display: flex;justify-content: space-between;">
                          <span>{{ user.username }}</span>
                          <span>                        
                            <Badge v-if="user.status == 3" status="success" text="在线" />
                            <Badge v-if="user.status == 0" status="error" text="离线" />
                            <Badge v-if="user.status == 1" status="warning" text="繁忙" />
                            <Badge v-if="user.status == 2" status="error" text="离开" />
                          </span>
                        </div>
                      </DropdownItem>
                  </Scroll>
                    
                </DropdownMenu>
            </Dropdown>
          
          <Scroll :height="collapseItemHeight2" :on-reach-bottom="recentlyMoreSession" :distance-to-edge="-10">
            <ul style="padding-bottom: 20px;" v-if="item.recently" v-show="(i == seller_id && (sessionKeyword == '' &&  searchKey == 'all') )" class="user-list">
              <li class="user" @click="showChat(session)" :class="currentSession && currentSession.session_id === session.session_id ? 'active' : ''" v-for="(session, index) in item.recently.data" :key="index">
                <a
                  href="javascript:"
                >
                  <i v-if="session.unread_count > 0">{{ session.unread_count }}</i>
                  <img class="head_img" :src="session.head_url">
                  <b style="width: 110px;" class="text-cut">{{ session.title }}</b>
                  <p style="width: 110px;" class="text-cut">{{ session.summary }}</p>
                  <span class="last_message_time"><Time :time="session.last_message_time*1" /></span>
                  <Badge v-if="session.transfer_mark == 1" style="position: absolute;right: 18px;top: 0px;" text="转" type="primary">
                      <a href="#" class="demo-badge"></a>
                  </Badge>
                  <div class="belongcsr" v-if="session.csr">
                    >{{session.csr.username}}
                  </div>
                </a>
              </li>
            </ul>
            <div v-if="(item.recently && item.recently.current_page >= item.recently.last_page)" class="scroll-nomore">没有更多了</div>
          </Scroll>
        </p>
      </Panel>
    </Collapse>
    </div>
  </div>

<Modal
    width="350"
    height="400"
    v-model="transferUserModal"
    :footer-hide="true"
    title="选择客服">
    <Scroll :height="300">    
      <List size="small">
          <ListItem v-for="(user, index) in childUser" :key="index">
            <div :style="{color: user.status == 3 ? '#222' : '#999'}" @click="transferCsr(user)" style="display: flex;justify-content: space-between;width: 100%;padding: 0px 10px;cursor: pointer;">
              <div>              
                {{ user.username }}
              </div>
              <div>              
                 <Badge v-if="user.status == 3" status="success" text="在线" />
                 <Badge v-if="user.status == 0" status="error" text="离线" />
                 <Badge v-if="user.status == 1" status="warning" text="繁忙" />
                 <Badge v-if="user.status == 2" status="error" text="离开" />
              </div>
            </div>
          </ListItem>
      </List>
    </Scroll>
</Modal>

</div>
</template>
<script>
import conf from "../../conf";
import RequestUtils from "../../../../utils/RequestUtils";
import Empty from "../empty.vue";

export default {
  components: {
    Empty,
  },
  data() {
    return {
      // 默认选中的值
      default_img: require("../../../../static/img/default_avatar.png"),
      error_img: 'this.src="'+require("../../../../static/img/default_avatar.png")+'";',
      loadImg: (imgSrc) => {
        return 'this.onload=null;this.src='+'"'+imgSrc+'";';
      },
      sessionKeyword: '',
      searchList: [],
      searchKey: 'all',
      collapseIndex: [1,2],
      collapseItemHeight: 300,
      collapseItemHeight2: 500,
      scrollHeight: 500,
      transferUserModal: false,
      // menu config
      sessionCsr: (this.$store.state.user) ? 'all' : '',
      selectSession: {},
      menuIndex: 1,
      transferIndex: null, // Show the menu that was clicked
      contextMenuData: {
        menuName: "sessionmenu",
        axis: {
          x: null,
          y: null
        },
        menulists: [
          {
            btnName: "分配客服",
            fnHandler: "Handler1"
          }
        ]
      }
    };
  },
  created() {
  },
  props: ["sessionList"],
  computed: {
    user: {
      get: function () {
        return this.$store.state.user;
      }
    },
    assignMode: {
      get: function () {
        return this.$store.state.assignMode;
      },
      set: function (value) {
        this.$store.commit('switdhAssignMode', value);
      }
    },
    currentSession: {
      get: function() {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        return this.$store.state.lazada.currentSessionData[seller_id];
      }
    },
    currentStore: {
      get: function () {
        return this.$store.state.lazada.currentStore;
      }
    },
    sessionData: {
      get: function() {
        return this.$store.state.lazada.sessionData;
      }
    },
    seller_id: {
      get: function() {
        return this.$store.state.lazada.currentStore.seller_id;
      }
    },
    session: {
      get: function() {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        if (this.$store.state.lazada.sessionData[seller_id]) {        
          return this.$store.state.lazada.sessionData[seller_id];
        }
        return [];
      },
    },
    searchSession: {
      get: function() {
        return this.$store.state.lazada.searchSession;
      }
    },
    childUser: {
      get: function () {
        return this.$store.state.childUser;
      }
    },
    searchKeyText: {
      get: function () {
        let str = '';
        if (this.searchKey == 'all') {
          str = '全部';
        } else if (this.searchKey == 'noreply') {
          str = '未回复';
        }
        return str;
      }
    }
  },
  methods: {
      onContextmenu(event) {
          this.$contextmenu({
              items: [
                  {
                      label: "返回(B)",
                      onClick: () => {
                          this.message = "返回(B)";
                          console.log("返回(B)");
                      }
                  },
                  { label: "前进(F)", disabled: true },
                  { label: "重新加载(R)", divided: true, icon: "el-icon-refresh" },
                  { label: "另存为(A)..." },
                  { label: "打印(P)...", icon: "el-icon-printer" },
                  { label: "投射(C)...", divided: true },
                  {
                      label: "使用网页翻译(T)",
                      divided: true,
                      minWidth: 0,
                      children: [{ label: "翻译成简体中文" }, { label: "翻译成繁体中文" }]
                  },
                  {
                      label: "截取网页(R)",
                      minWidth: 0,
                      children: [
                          {
                              label: "截取可视化区域",
                              onClick: () => {
                                  this.message = "截取可视化区域";
                                  console.log("截取可视化区域");
                              }
                          },
                          { label: "截取全屏" }
                      ]
                  },
                  { label: "查看网页源代码(V)", icon: "el-icon-view" },
                  { label: "检查(N)" }
              ],
              event,
              //x: event.clientX,
              //y: event.clientY,
              customClass: "custom-class",
              zIndex: 3,
              minWidth: 230
          });
          return false;
      },
    showMenu(index) {
      this.transferIndex = index; // tranfer index to child component
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      this.contextMenuData.axis = {
        x,
        y
      };
    },
    transferCsrModelShow (session) {
      this.selectSession = session;
      this.transferUserModal = true;
    },
    transferCsr (user) {
      if (user.status != 3) {
        return false;
      }
      this.transferUserModal = false;
      RequestUtils.webSocketSend('transferCsr', {
        'platform': 'lazada',
        'session_id': this.selectSession.id,
        'admin_id': user.id
      });
    },
    selectDropItem(name) {
      this.searchKey = name;
      if (name == 'noreply') {
        this.getSearchSession();
      }
    },
    showChat(session) {
      console.log(session);
      this.$emit('showChat', session);
    },
    invitation(session) {
      if (this.assignMode == 'view') {
        this.showChat(session);
      } else if (this.assignMode == 'invitation') {      
        RequestUtils.webSocketSend('inviteSession', {
          'platform': 'lazada',
          'session_id': session.id
        });
      }
    },
    csrSession(user) {
      this.sessionCsr = user;

      let param = new FormData();
      param.set("store_id", this.currentStore.id);
      param.set("tab", 'recently');
      param.set("page", 1);
      if (this.sessionCsr && this.sessionCsr.id) {      
        param.set("admin_id", this.sessionCsr.id);
      } else if (this.sessionCsr == 'all') {
        param.set("scope", 'all');
      }

      RequestUtils.request(conf.moreSession(), param)
      .then(data => {
        this.$store.commit("lazada/setRecentlyData", data);  
      })
    },
    moreSession(tab) {
      return new Promise( (resolve, reject) => {
        if (this.session && this.session[tab]) {
          let pageInfo = this.session[tab];
          if (pageInfo.current_page < pageInfo.last_page) {

            let param = new FormData();
            param.set("store_id", this.currentStore.id);
            param.set("tab", tab);
            param.set("page", pageInfo.current_page+1);
            if (this.sessionCsr && this.sessionCsr.id) {
              param.set("admin_id", this.sessionCsr.id);
            } else if (this.sessionCsr == 'all') {
              param.set("scope", 'all');
            }

            RequestUtils.request(conf.moreSession(), param)
            .then(data => {
              this.$store.commit("lazada/pushSessionList", {
                tab: tab,
                seller_id: this.seller_id,
                data: data
              });
            })
          } else {
            reject();
          }
        }

        resolve();
      });
    },
    invitionMoreSession () {
      this.moreSession('invition');
    },
    recentlyMoreSession () {
      this.moreSession('recently');
    },
    getSearchSession (page = 1) {
      let param = new FormData();
      param.set("page", page);
      param.set("store_id", this.currentStore.id);
      param.set("keyword", this.sessionKeyword);
      param.set("searchKey", this.searchKey);

      if (typeof page != 'number' || page == 1) {
        this.$store.commit("lazada/setSearchSession", null);
      }
      RequestUtils.request(conf.searchSession(), param)
      .then(data => {
        this.$store.commit("lazada/setSearchSession", data);
      })
    },
    getSearchSessionMore() {
      return new Promise(resolve => {
        if (this.searchSession.current_page < this.searchSession.last_page) {        
          this.getSearchSession(this.searchSession.current_page+1);
        }
        resolve();
      });      
    },
  },
  mounted: function() {
    let collapseHeight = document.querySelector('body').offsetHeight - 64 - 36 - 56 - 38*2 - 32*2;
    this.collapseItemHeight = collapseHeight*0.3;
    this.collapseItemHeight2 = collapseHeight*0.7;
    this.scrollHeight = document.querySelector('body').offsetHeight - 64 - 36 - 46 - 44;
  }
};
</script>
<style lang="scss">
@import "@/static/styles/theme";

.group-box {
  height: 100%;

  .count {
    color: #aaaaaa;
  }

  li {
    list-style: none;
    position: relative;
    font-size: 1.2rem;
    cursor: pointer;
    font-weight: 200;
    padding: 1rem 0;
    box-sizing: unset;

    h5 {
      padding: 0.5rem 0;
      cursor: pointer;
      font-size: 1.3rem;
      font-weight: 200;

      i {
        vertical-align: baseline;
      }
    }

    img {
      width: 4.4rem;
      height: 4.4rem;
      position: absolute;
      top: 0.4rem;
      left: 2rem;
      &:after{
        content: "";
        display: inline-block;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 4.4rem;
        height: 4.4rem;
        background: url("https://fahuo.isellso.net/assets/img/avatar.png") no-repeat;
        background-size: 100% ;
        background-color: #fff;
      }
    }

    .last_message_time {
      position: absolute;
      right: 0px;
      top: 1rem;
      font-size: 10px;
    }

    b {
      position: absolute;
      font-size: 1.3rem;
      left: 7.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 600;
      top: 0.6rem;
    }

    p {
      position: absolute;
      left: 7.5rem;
      bottom: 0.4rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 75%;
      font-size: 1.1rem;
      color: #aaaaaa;
    }
  }
  li.active {
      background-color: $color-gray !important;
  }

  .user {
    height: 5.2rem;
    position: relative;

    a {
      display: block;
      width: 100%;
      height: 100%;
      color: $color-default;
      position: relative;

      i {
        display: inline-block;
        width: 1.8rem;
        height: 1.6rem;
        background-color: #ff0000;
        border-radius: 50%;
        color: $color-write;
        text-align: center;
        font-style: normal;
        position: absolute;
        left: 1rem;
        top: 0;
        z-index: 99;
      }

      p {
        width: 12rem;
      }
    }

    .belongcsr {
      position: absolute;
      bottom: 0px;right: 0px;
      color: #ed4d2d;
    }

    &:hover {
      background-color: $color-gray !important;

      & > i {
        color: $color-default;
        background-color: $color-write;
      }
    }

    .active {
      background-color: $color-gray !important;
    }

    & > i {
      position: absolute;
      right: 1rem;
      bottom: 1.6rem;
      cursor: pointer;
      border-radius: 50%;
      padding: 0.2rem;
      text-align: center;
      color: $color-light-gray;

      &:hover {
        color: $color-default;
        background-color: $color-write;
      }
    }
  }
}
</style>
